import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import BasicModals from './Basic';
import SizesModals from './Sizes';
import StaticModal from './Staic';
import VaryingContent from './VaryingContent';

const ModalsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Modal' parent='Ui Kits' title='Modal' />
      <Row>
        <StaticModal />
        <BasicModals />
        <VaryingContent />
        <SizesModals />
      </Row>
    </Container>
  );
};

export default ModalsContainer;
